<script>
import JobForm from './JobForm'

export default {
  components: {
    JobForm
  },

  props: {
    id: {
      required: true
    }
  },

  data() {
    return {
      job: null
    }
  },

  created() {
    this.Loading.yes = true

    this.axios.get('/jobs/' + this.id)
      .then(response => (this.job = response.data))
      .then(() => (this.Loading.yes = false))
  }
}
</script>

<template>
  <section class="hero is-primary">
    <div
      class="container"
      v-if="job">
      <h1 class="title is-2">Editer l'emploi</h1>

      <job-form
        :job="job"/>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 640px;
}

.hero {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/PageJobEdit.vue